import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import Switcher from "../../../components/switcher";

import ScrollToTop from "../../../components/scroll-to-top";

export default function Refund(){
    return(
        <>
        <Navbar navClass="defaultscroll is-sticky"/>
        <section className="relative table w-full py-32 lg:py-40 bg-gray-50 dark:bg-slate-800">
            <div className="container relative">
                <div className="grid grid-cols-1 text-center mt-10">
                    <h3 className="text-3xl leading-normal font-semibold">Refund Policy</h3>
                </div>
            </div>
            
            <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
                <ul className="tracking-[0.5px] mb-0 inline-block">
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500"><Link to="/">Sportyfi</Link></li>
                    <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500"><Link to="">Help Center</Link></li>
                    <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block uppercase text-[13px] font-bold text-orange-500" aria-current="page">Refund & Cancellation</li>
                </ul>
            </div>
        </section>

          <section className="py-10 px-6 max-w-4xl mx-auto  shadow text-gray-800 leading-relaxed">
     
      
      <h5><strong> Thank you for shopping with spotyfi and More</strong> </h5> .<p className="mb-6"> We
        strive to provide high-quality products and exceptional customer
        service. If you are not completely satisfied with your purchase, please
        review our Return & Refund Policy below.
      </p>

      {/* 1. Returns */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">1. Returns</h2>

      {/* 1.1 Eligibility */}
      <h3 className="text-xl font-medium mb-2 text-gray-900">1.1 Eligibility:</h3>
      <ul className="list-disc pl-6 space-y-2 mb-4">
        <li>Returns are accepted within <strong>1 day</strong> from the date of delivery.</li>
        <li>Items must be in their original condition, unused, and with all original packaging and tags intact.</li>
        <li>Certain products are non-returnable, including personalized or custom-made items.</li>
      </ul>

      {/* 1.2 How to Return */}
      <h3 className="text-xl font-medium mb-2 text-gray-900">1.2 How to Return:</h3>
      <ul className="list-disc pl-6 space-y-2 mb-4">
        <li>
          Contact our customer support team at{" "}
          <strong>sportyfi@gmail.com</strong> to initiate a return.
        </li>
        <li>
          Provide your order number, details of the item(s) you wish to return,
          and the reason for the return.
        </li>
        <li>
          Our team will provide instructions on how to return the item(s) and a
          return authorization if applicable.
        </li>
      </ul>

      {/* 1.3 Return Shipping */}
      <h3 className="text-xl font-medium mb-2 text-gray-900">1.3 Return Shipping:</h3>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>
          Customers are responsible for the cost of return shipping unless the
          return is due to our error (e.g., incorrect or defective items).
        </li>
        <li>
          We recommend using a trackable shipping service or purchasing shipping
          insurance. We are not responsible for items lost or damaged in
          transit.
        </li>
      </ul>

      {/* 2. Refunds */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">2. Refunds</h2>

      {/* 2.1 Processing */}
      <h3 className="text-xl font-medium mb-2 text-gray-900">2.1 Processing:</h3>
      <p className="mb-4">
        Once we receive and inspect your returned item(s), we will notify you of
        the approval or rejection of your refund. If approved, a refund will be
        credited to your original payment method within{" "}
        <strong>7–10 business days</strong> from the date we receive the
        returned item(s).
      </p>

      {/* 2.2 Partial Refunds */}
      <h3 className="text-xl font-medium mb-2 text-gray-900">2.2 Partial Refunds:</h3>
      <ul className="list-disc pl-6 space-y-2 mb-4">
        <li>
          If the returned item is damaged, used, or not in its original
          condition, a partial refund may be issued.
        </li>
        <li>Shipping costs are non-refundable.</li>
      </ul>

      {/* 2.3 Exchange */}
      <h3 className="text-xl font-medium mb-2 text-gray-900">2.3 Exchange:</h3>
      <p className="mb-6">
        If you prefer an exchange, please contact our customer support team to
        discuss available options. Exchanges are subject to product
        availability.
      </p>

      {/* 3. Cancellations */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">3. Cancellations</h2>

      {/* 3.1 Order Cancellations */}
      <h3 className="text-xl font-medium mb-2 text-gray-900">3.1 Order Cancellations:</h3>
      <p className="mb-6">
        You may cancel your order within <strong>2 hours</strong> of placing it
        by contacting <strong>sportyfi@gmail.com</strong>. Orders that have
        already been processed or shipped cannot be canceled.
      </p>

      {/* 4. Damaged or Defective Items */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">
        4. Damaged or Defective Items
      </h2>
      <h3 className="text-xl font-medium mb-2 text-gray-900">4.1 Reporting Issues:</h3>
      <p className="mb-6">
        If you receive a damaged or defective item, please contact our customer
        support team within <strong>48 hours</strong> of receipt with your order
        number and photographic evidence of the issue. We will arrange for a
        replacement or refund as appropriate.
      </p>

      {/* 5. Contact Us */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">5. Contact Us</h2>
      <ul className="list-none pl-0 space-y-1 mb-6">
        <li>
          <strong>Contact Person:</strong> Anila Dhar
        </li>
        <li>
          <strong>Brand:</strong> spotyfi
        </li>
        <li>
          <strong>Address:</strong> Sambit Villa, Ghatikia, Bhubaneswar, India
        </li>
        <li>
          <strong>Email:</strong> sportyfi@gmail.com
        </li>
      </ul>

      {/* 6. Policy Changes */}
      <h2 className="text-2xl font-semibold mb-3 text-gray-900">6. Policy Changes</h2>
      <p>
        We may update this Return & Refund Policy from time to time. Any changes
        will be posted on this page with an updated effective date. We encourage
        you to review this policy periodically to stay informed about our
        return and refund practices.
      </p>
    </section>
        <Footer/>
        <Switcher/>
        <ScrollToTop/>
        </>
    )
}